@if (isForbidLoading || isDepositForbid) {
  <deposit-withdraw-forbid [isLoading]="isForbidLoading"></deposit-withdraw-forbid>
} @else if (!hasAvailableCardDepositCurrencies) {
  <div class="deposit-crypto-disabled" [appLoading]="paymentLoading">
    @if (!this.paymentLoading) {
      <i origin class="fi-information-circle"></i>
      <p class="title">Payment method unavailable</p>
      <p class="text">
        This payment method is temporarily unavailable. Please try again later or choose a different payment method to
        continue.
      </p>
    }
  </div>
} @else {
  <form [formGroup]="form" class="scroll-cont">
    <div class="section">
      <div class="cont">
        <div class="row">
          <!-- 選擇bonus -->
          <div class="item">
            <app-deposit-bonus-dropdown
              [currentCurrency]="currentCurrency"
              (bonusLoadingChange)="bonusLoading = $event"
              (activityNo)="activityNo = $event"
            ></app-deposit-bonus-dropdown>
          </div>
        </div>

        <div class="row flex-column">
          <!-- You will pay（法幣） -->
          <div class="item flex-row">
            <div class="item-inner">
              <div class="label">
                <span [class.error]="!!getPayError">You pay with</span>
              </div>
              <cs-input
                placeholder="Enter amount"
                [inputMode]="'decimal'"
                formControlName="payAmount"
                [hasError]="!!getPayError"
                [disabled]="!isAllLoaded()"
                [marginBottom]="'0'"
              ></cs-input>
            </div>
            <div class="item-inner">
              <div class="label"></div>
              <cs-select
                [(value)]="currentPayFiat"
                [options]="payFiatList"
                [disabled]="!isAllLoaded()"
                (valueChange)="onPayFiatChange()"
              ></cs-select>
            </div>
          </div>
          @if (getPayError) {
            <div class="msg error">{{ getPayError }}</div>
          }
        </div>

        <div class="row flex-column">
          <!-- You will get（Crypto，可輸入） -->
          <div class="item flex-row">
            <div class="item-inner">
              <div class="label">
                <span [class.error]="!!getPayError">You get</span>
                <app-tool-tip [direction]="['up']">
                  <span origin class="refresh-icon">
                    <i class="fi-information-circle-filled"></i>
                  </span>
                  <div tooltip>
                    {{
                      'The final exchange rate may differ slightly from the quoted crypto amount due to market fluctuations. Please refresh to get the latest rate.'
                    }}
                  </div>
                </app-tool-tip>
              </div>
              <cs-input
                type="number"
                placeholder="Enter amount"
                [inputMode]="'decimal'"
                [disabled]="!isAllLoaded()"
                formControlName="getAmount"
                [hasError]="!!getPayError"
                [marginBottom]="'0'"
                [suffixIconName]="'icon-refresh2'"
                (suffixIconClick)="handleFetch()"
                [readonly]="true"
              ></cs-input>
            </div>
            <div class="item-inner">
              <div class="label"></div>
              <cs-select
                [(value)]="currentCurrency"
                [options]="getFiatList"
                [disabled]="!isAllLoaded()"
                (valueChange)="onCurrencyChange()"
              ></cs-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="item">
            <div class="card-note">
              <span>You can use</span>
              <div class="card-payments-wrapper">
                <div class="card-payment-icons">
                  <img
                    [src]="
                      (appService.themeSwitch$ | async) === 'sun'
                        ? 'assets/images/media/brand/payment-provider-logos/visa.colour.svg'
                        : 'assets/images/media/brand/payment-provider-logos/visa.white.svg'
                    "
                    alt="VISA"
                  />
                  <img src="assets/images/media/brand/payment-provider-logos/mastercard.colour.svg" alt="Mastercard" />
                  <img
                    [src]="
                      (appService.themeSwitch$ | async) === 'sun'
                        ? 'assets/images/media/brand/payment-provider-logos/apple-pay.colour.svg'
                        : 'assets/images/media/brand/payment-provider-logos/apple-pay.white.svg'
                    "
                    alt="Apple Pay"
                  />
                  <img
                    [src]="
                      (appService.themeSwitch$ | async) === 'sun'
                        ? 'assets/images/media/brand/payment-provider-logos/google-pay.colour.svg'
                        : 'assets/images/media/brand/payment-provider-logos/google-pay.white.svg'
                    "
                    alt="Google Pay"
                  />
                </div>
              </div>
            </div>
            <cs-button
              label="Next"
              color="accent"
              size="large"
              [loading]="!isAllLoaded()"
              [disabled]="!canSubmit()"
              (buttonClick)="submit()"
            ></cs-button>
          </div>
        </div>
      </div>

      <div class="note">
        <span>Need help?</span>
        <cs-button
          (buttonClick)="contactSupport()"
          color="secondary"
          width="auto"
          size="small"
          label="Get live support"
        ></cs-button>
      </div>
    </div>
  </form>
}
